import {css} from '@emotion/css';
import {Breakpoints, mq} from '../../../styles/js/mixins';
import {colours, spacing} from '../../../styles/js/variables';

const styles = {
  accordion: css`
    label: accordion;
  `,
  item: (isOpen?: boolean): string => css`
    label: accordion__item;
    margin-bottom: ${spacing.XS};
    border-bottom: 1px solid ${colours.border.LIGHT_GRAY};

    &:last-of-type {
      border-bottom: none;
    }

    ${isOpen ? 'p {margin: 0;}' : ''}
  `,
  label: css`
    label: accordion__label;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${spacing.XS};
    color: ${colours.brand.SECONDARY};
    outline: none;
    cursor: pointer;
    user-select: none;

    h3 {
      margin-bottom: 0;
    }

    ${mq(Breakpoints.DESKTOP)} {
      // Adding :hover for desktop only because on touch devices
      // the hover state is activated by tapping
      // Which means that, once you tap it, it will stay blue colored
      // until you tap away. This shouldn't be a massive issue when opening,
      // but it happens when you tap to close as well, leaving the closed item
      // blue-colored as well, as if it was selected.
      &:hover {
        color: ${colours.brand.SECONDARY};
      }
    }
  `,
  content: (isOpen?: boolean): string => css`
    label: accordion__content;
    margin-bottom: 0;
    overflow: hidden;

    ${isOpen
      ? `
    margin-bottom: ${spacing.XS};

    `
      : ''}
  `,
};

export default styles;
